import type { OpsMateCustomer } from "../types";
import { CustomerCard } from "./CustomerCard";
import { GroupsList } from "./GroupsList";
import { DraftSection } from "./DraftSection";
import { LogoutButton } from "./LogoutButton";
import { Button } from "./Button";

interface CustomerViewProps {
  customer: OpsMateCustomer;
  conversationId: string;
  onSearch: () => void;
}

export function CustomerView({ customer, conversationId, onSearch }: CustomerViewProps) {
  return (
    <div className="flex min-h-[calc(100vh-32px)] flex-col">
      <div className="mb-2 flex justify-end">
        <Button variant="icon" title="Search by email" onClick={onSearch}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
        </Button>
      </div>

      <CustomerCard customer={customer} />
      <GroupsList groups={customer.settings?.groups} />
      <DraftSection conversationId={conversationId} />
      <LogoutButton />
    </div>
  );
}
